import PropTypes from "prop-types";
import React from "react";
import Select from "react-select";
import { appendClassName } from "./view-helpers";
var setDefaultStyle = {
  option: function option() {
    return {};
  },
  control: function control() {
    return {};
  },
  dropdownIndicator: function dropdownIndicator() {
    return {};
  },
  indicatorSeparator: function indicatorSeparator() {
    return {};
  }
};

function Sorting(_ref) {
  var className = _ref.className,
      label = _ref.label,
      _onChange = _ref.onChange,
      options = _ref.options,
      value = _ref.value;
  var selectedValue = value;
  var selectedOption = selectedValue ? options.find(function (option) {
    return option.value === selectedValue;
  }) : null;
  return React.createElement("div", {
    className: appendClassName("sui-sorting", className)
  }, label && React.createElement("div", {
    className: "sui-sorting__label"
  }, label), React.createElement(Select, {
    className: "sui-select",
    classNamePrefix: "sui-select",
    value: selectedOption,
    onChange: function onChange(o) {
      return _onChange(o.value);
    },
    options: options,
    isSearchable: false,
    styles: setDefaultStyle
  }));
}

Sorting.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string
  })).isRequired,
  value: PropTypes.string
};
export default Sorting;